<template>
  <div class="account">
    <div class="title">
      绑定支付宝
    </div>
    <div class="notice" style="color:#BBBBBB;margin:50px auto 46px 52px">
      Tip：请绑定本人支付宝账号，否则无法正常提现。为确保资金安全，请谨慎填写。
    </div>
    <a-form :form="form" style="width:100%" :label-col="{ span: 2}" :wrapper-col="{ span: 20 }">
      <a-form-item label="真实姓名">
        <span>{{ userInfo.username }}</span>
      </a-form-item>
      <a-form-item label="支付宝账号">
        <a-input
          @change="accountChange"
          placeholder="请输入支付宝账号（手机号/邮箱）	"
          v-decorator="['alipay_account',{rules:[{
            required:true,
            message: '*请输入支付宝账号（手机号/邮箱）	'
          }]}]"
          style="width:288px;height:40px;border-radius:8px"
        >
          <!-- <span class="alipay-icon" slot="prefix"></span></a-input> -->
        </a-input></a-form-item>
      <a-form-item label="注册手机">
        <div style="width:288px; display:flex; justify-content: space-between">
          <span >{{ userInfo.phone | phoneAddCode }}</span>
          <a-button
            :disabled="codeState.sendBtn"
            :class="{'getCode-ing':codeState.isSend}"
            style="width: 130px; height:42px; border-radius:8px"
            v-text=" !codeState.isSend?'获取验证码': `${codeState.time}s`"
            @click.stop.prevent="getCode"
          >
          </a-button>
        </div>

      </a-form-item>
      <a-form-item label="验证码">
        <a-input
          @change="codeChange"
          placeholder="请输入验证码"
          v-decorator="['code',{rules:[{
            required:true,
            message: '*请输入验证码'
          }]}]"
          style="width:288px;height:40px;border-radius:8px"
        >
          <!-- <span
              slot="prefix"
              class="chatCode"

            ></span></a-input> -->
        </a-input>
      </a-form-item>
      <a-row>
        <a-col :offset="2">
          <a-button style="margin-left: 10px;" type="primary" :disabled="!canBind" @click="submit">绑定</a-button>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import UploadImage from '@/components/Zpace/UploadImage/UploadImage'
import { phoneAddCode } from '@/utils/util.js'
export default {
  name: 'BindAliPay',
  data () {
    return {
      form: this.$form.createForm(this),
      codeState: {
        isSend: false,
        time: 60,
        status: 'success',
        errorText: ''
      },
      timer: null,
      queryParams: {
        alipay_account: '',
        code: ''
      }
    }
  },
  components: {
    UploadImage
  },
  filters: {
    phoneAddCode
  },
  created () {
  },
  computed: {
    userInfo () {
      return this.$store.state.user.info
    },
    canBind () {
      return this.queryParams.alipay_account && this.queryParams.code
    }

  },
  mounted () {
  },
  methods: {
    submit () {
      this.form.validateFields((errors, values) => {
        if (errors) {
          return false
        }

        this.$api.user.bindAlipay(values).then(async res => {
          if (res.status === 'ok') {
            this.$message.success('绑定成功')
            await this.$store.dispatch('GetInfo')
            if (this.$route.query.back && this.$route.query.back === 'withdraw') {
              this.$router.push({
                path: '/manageUser/withdraw'
              })
            } else {
              this.$router.push({
                path: '/manageUser/account'
              })
            }
          } else {
            if (res.message.key === 1007) {
              this.form.setFields({
                code: {
                  errors: [new Error(`*${res.message.message}`)]
                }
              })
            }
          }
        })
      })
    },
    nameChange (e) {
      this.queryParams.real_name = e.target.value
    },
    accountChange (e) {
      this.queryParams.alipay_account = e.target.value
    },
    codeChange (e) {
      this.queryParams.code = e.target.value
    },
    checkIdCard (rule, value, callback) {
      console.log(rule, value)
      if (value && value.length !== 18) {
        callback(new Error('身份证号格式错误'))
      } else {
        callback()
      }
    },
    getCode () {
      if (this.codeState.isSend) {
        return false
      }
      const params = {
        phone: this.userInfo.phone,
        type: 1 // 1普通验证码  2注销验证码
      }

      this.$api.user.getVerifyCode(params).then(res => {
        if (res.message.key === 1006) {
          window.tncode.show()
          window.tncode.onSendResult((tn_check, key) => {
            console.log(tn_check, key)
            this.$api.user.getVerifyCode(Object.assign(params, { tn_check, key })).then(res => {
              if (res.status === 'ok') {
                this.$message.success('发送成功')
                this.codeState.isSend = true
                this.timer = setInterval(() => {
                  this.codeState.time -= 1
                  if (this.codeState.time === 0) {
                    this.codeState.time = 60
                    this.codeState.isSend = false
                    clearInterval(this.timer)
                  }
                }, 1000)
                window.tncode.hide()
              } else {
                window.tncode._showmsg(res.message.message)
              }
            })
          })
        } else if (res.message.key === 10000) {

        } else {
          this.codeState.isSend = true
          this.timer = setInterval(() => {
            this.codeState.time -= 1
            if (this.codeState.time === 0) {
              this.codeState.time = 60
              this.codeState.isSend = false
              clearInterval(this.timer)
            }
          }, 1000)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/
.ant-input-affix-wrapper .ant-input:not(:first-child){
  padding-left: 40px;
}
.account{
  background-color: #ffffff;
  min-height: 800px;
  /deep/
  .ant-btn {
    width: 100px;
   height: 40px;
   border-radius: 8px;
  }
  .title {
    color: @primary-color;
    font-size: 14px;
    padding: 17px 0 17px 24px;
    border-bottom: 1px solid #F2F2F2;
  }
  .content {
    padding: 36px 0 0 0px;
    .avatar {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border:1px solid #F2F2F2;
      overflow: hidden;
      /deep/
      .upload-img{
        background-size: auto;
        background-position: -80px -273px;
      }
      /deep/
      .ant-upload.ant-upload-select-picture-card:hover{
        border: none
      }
      .reset-text {
        display: block;
        width:24px;
        margin-top: 14px;
        height: 40px;
        color: #ffffff;
        font-size: 12px;
        line-height: 1;

      }

      .mask-loading{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        justify-content: center;
        align-items: center;
      }
      .loading-img{
        width: 24px;
        height: 24px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -12px;
        margin-top: -12px;
        display: block;
        animation:roateloading 1s linear infinite ;
      }
      @keyframes roateloading {
        0%{
          transform: rotate(0deg);
        }
        100%{
          transform: rotate(360deg);
        }
      }
    }
    .bingCard {
      cursor: pointer;
      color: @primary-color;
      margin-bottom: 0;
      &:hover {
        text-decoration: underline;
      }
    }
    .modify{
      cursor: pointer;
      margin-left: 34px;
      align-items: center;
      .modify-icon {
        vertical-align: middle;
      }
      .text {
        margin-left: 5px;
        color: @primary-color;
        font-style: normal;
        &:hover {

          text-decoration: underline;

        }
      }
    }

  }
  /deep/
  .ant-form-item label{
    margin-right: 6px;
  }
  /deep/
  .ant-form-item-control{
    display: flex;
    align-items: center;
  }
  .ant-form-item-with-help{
    margin-bottom: 24px;
  }
  /deep/
  .ant-form-explain{
    margin-left: 16px;
  }
}
</style>
